import React from "react";
import ReactDOM from "react-dom";
import "./assests/css/tailwind.css";
import "./assests/css/toaster-style.css";
import "./assests/css/loader-style.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/store";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);

reportWebVitals();
